import * as React from "react";
import { memo } from "react";
const SvgChevronRight = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.50332 5.24959L13.2533 11.9996L6.50332 18.7496L8.62464 20.8709L17.496 11.9996L8.62464 3.12827L6.50332 5.24959Z", fill: "currentColor" }));
const Memo = memo(SvgChevronRight);
export default Memo;
